export default __webpack_public_path__ + "static/media/2020-medi-app.be01cb87.png";